/**
 * Simple lock mechanism to prevent concurrent auth operations
 */
class AuthLock {
    private locks = new Map<string, Promise<any>>();

    async acquire<T>(key: string, operation: () => Promise<T>): Promise<T> {
        const existingLock = this.locks.get(key);
        if (existingLock) {
            // Wait for existing operation to complete
            await existingLock;
        }

        // Create new lock
        const lockPromise = operation().finally(() => {
            // Clean up lock when operation completes
            this.locks.delete(key);
        });

        this.locks.set(key, lockPromise);
        return lockPromise;
    }

    isLocked(key: string): boolean {
        return this.locks.has(key);
    }
}

export const authLock = new AuthLock();
